// extracted by mini-css-extract-plugin
export var productImage = "_zb-0";